export const CATEGORIES = [
  { value: "notizbuch", label: "Notizbücher", plural: "Notizbücher" },
  { value: "stift", label: "Stifte", plural: "Stifte" },
  { value: "geschenk", label: "Geschenke", plural: "Geschenke" },
  { value: "buch", label: "Bücher", plural: "Bücher" },
  { value: "naturkost", label: "Naturkost", plural: "Naturkost" },
  { value: "kleidung", label: "Islamische Kleidung", plural: "Islamische Kleidung" },
  { value: "parfum", label: "Parfüm", plural: "Parfüms" },
];

export const CATEGORY_LABEL = CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label;
  return acc;
}, {});

export const formatPrice = (n) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(Number(n) || 0);
